module.exports = __webpack_public_path__ + "static/media/loading.5e85b43b.svg";